'use client'

// MUI Imports
import Grid from '@mui/material/Grid'

// Component Imports
import CreditNoteListTable from './CreditNoteListTable'
import CreditNoteCard from './CreditNoteCard'
import CreditNoteGrid from './CreditNoteGrid'

const CreditNoteList = ({
    viewMode = 'table',
    data,
    stats,
    loading,
    permissions,
    onAddClick,
    onShowClick,
    onEditClick,
    onCancelClick,
    onDeleteClick,
    onRequestApprovalClick,
    totalRecords,
    currentPage,
    itemsPerPage,
    onPageChange,
    onStatusClick,
    searchTerm
}) => {
    return (
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 0 }}>
            <div style={{ width: '100%', padding: 0 }}>
                <CreditNoteCard stats={stats} onStatusClick={onStatusClick} />
            </div>
            <div style={{ width: '100%', marginTop: '16px' }}>
                {viewMode === 'table' ? (
                    <CreditNoteListTable
                        data={data}
                        loading={loading}
                        permissions={permissions}
                        onAddClick={onAddClick}
                        onShowClick={onShowClick}
                        onEditClick={onEditClick}
                        onCancelClick={onCancelClick}
                        onDeleteClick={onDeleteClick}
                        onRequestApprovalClick={onRequestApprovalClick}
                        totalRecords={totalRecords}
                        currentPage={currentPage}
                        itemsPerPage={itemsPerPage}
                        onPageChange={onPageChange}
                        onStatusChange={onStatusClick}
                        searchTerm={searchTerm}
                    />
                ) : (
                    <CreditNoteGrid
                        data={data}
                        loading={loading}
                        permissions={permissions}
                        onShowClick={onShowClick}
                        onEditClick={onEditClick}
                        onCancelClick={onCancelClick}
                        onDeleteClick={onDeleteClick}
                        onRequestApprovalClick={onRequestApprovalClick}
                        totalRecords={totalRecords}
                        currentPage={currentPage}
                        itemsPerPage={itemsPerPage}
                        onPageChange={onPageChange}
                    />
                )}
            </div>
        </div>
    )
}

export default CreditNoteList
